import { render, staticRenderFns } from "./PharmacyGroupChiefPharmacist.vue?vue&type=template&id=548493ba"
import script from "./PharmacyGroupChiefPharmacist.vue?vue&type=script&lang=js"
export * from "./PharmacyGroupChiefPharmacist.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports